import React, { useState ,useEffect} from 'react'
import {AppBar,Avatar,Button,Toolbar,Typography} from "@material-ui/core";
import useStyles from "./styles";
import decode from "jwt-decode";
import {Link,useHistory,useLocation} from "react-router-dom";
import { useDispatch } from 'react-redux';
import {LOGOUT} from "../../constants/actionTypes";

const Navbar = () => {
    const [user,setUser]=useState(JSON.parse(localStorage.getItem("profile")));
    const dispatch=useDispatch();
    const history=useHistory();
    const location=useLocation();
    const classes=useStyles();
    const logout=()=>{
        dispatch({type:LOGOUT})
        history.push("/");
        setUser(null);
    }
    useEffect(()=>{
        const token=user?.token;
        if(token){
            const decodedToken=decode(token);
            if(decodedToken.exp * 1000 < new Date().getTime()) logout();
        }

        setUser(JSON.parse(localStorage.getItem("profile")))
    },[location]);
  return (
    <AppBar className={classes.appBar} position="static" color="inherit">
        <div className={classes.brandContainer}>
            <Typography component={Link} to='/' variant="h2" className={classes.heading} align="center">Keeper</Typography>
        </div>
        <Toolbar className={classes.toolbar}>
            {user?(
                <div className={classes.profile}>
                    <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>{user.result.name.charAt(0)}</Avatar>
                    <Typography className={classes.userName} variant="h6">{user.result.name}</Typography>
                    <Button variant="contained" color="secondary" onClick={logout}>Logout</Button>
                </div>
            ):(
                <Button component={Link} to="/auth" variant="contained" color="primary">Login</Button>
            )}
        </Toolbar>
    </AppBar>
  )
}

export default Navbar